// extracted by mini-css-extract-plugin
export default {"container":"ActivityItem_container__2a5ew","openActivityIcon":"ActivityItem_openActivityIcon__lg4ZU","date":"ActivityItem_date__D4+6x"};